import React from "react"
import CTAMenuLink from "../../../modules/cta_menu_link_module"
import CTABtnModule from "../../../modules/cta_btn_module";

const SubMenu = ({data, dropdown_content}) => {
  return (
    <>
    {data?.length > 0 && 
      <div className="submenu_outter">
        <div className="submenu">
            <ul>
              {data?.map((item, index) => {
                return(
                  <li key={item.id} className={item?.label ? "menu_item_"+item?.label.replace(/ /g, '_').toLowerCase() : ""}>
                    <CTAMenuLink item={item} />
                  </li>
                )
              })}         
            </ul>
            {dropdown_content?.show && 
              <div className="dropdown_content">
                  <div className="title">{dropdown_content?.title}</div>
                  <div className="content">{dropdown_content?.content}</div>
                  <CTABtnModule button_cta={dropdown_content?.button_cta} />
              </div>
            }
        </div>
      </div>
    }
    </>
  )
}

const HeaderMenu = ({data, dropdown_content}) => {

  return (
    <>
    {data?.length > 0 && 
      <div className="navigation">
          <ul className="parent_menu">
            {data?.map((item, index) => {
              return(
                item?.menu_items?.label.indexOf("valuation") > -1 ?
                <li key={item.id} className={"menu_item valuation"}>
                  <CTAMenuLink item={item.menu_items} />
                </li>
                :
                <li key={item.id} className={item?.menu_items?.label ? "menu_item_"+item?.menu_items?.label.replace(/ /g, '_').toLowerCase() : ""}>
                  <CTAMenuLink item={item.menu_items} />

                  {item?.sub_menu_item?.length > 0 && 
                    <SubMenu data={item?.sub_menu_item} dropdown_content={dropdown_content}/>
                  }
                </li>
              )
            })}         
          </ul>
      </div>
    }
    </>
  )
}

export default HeaderMenu